module.exports = __webpack_public_path__ + "static/media/bunbury_turf_club.c2832f74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/bunbury_turf_club.jpg
// module id = 497
// module chunks = 0